export const NotificationStatus = {
  NONE: 0,
  SUCCESS: 1,
  FAILURE: 2,
};
